import * as React from "react";
import {
  Box,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import { PredefinedObstacle } from "../../../../hooks/usePredefinedObstacle";
import { getObstacleImageUrl } from "../utils/getObstacleImageUrl";

interface Props {
  selectedObstacle: PredefinedObstacle | null;
  imageError: boolean;
  onImageError: () => void;
}

export const ObstaclePreview: React.FC<Props> = ({
  selectedObstacle,
  imageError,
  onImageError,
}) => {
  return (
    <Box sx={{
      width: { xs: '100%', md: '400px', lg: '500px', xl: '562px' },
      flexShrink: 0,
      p: 2,
      display: 'flex',
      flexDirection: 'column',
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 1
    }}>
      <Stack spacing={2} sx={{ height: '100%' }}>
        <Typography variant="h6">Preview</Typography>
        <Divider />
        {selectedObstacle ? (
          <Stack spacing={2} sx={{ flex: 1, overflowY: 'auto', pr: 1 }}>
            <Typography variant="subtitle1">{selectedObstacle.name}</Typography>
            <Box sx={{
              width: 'calc(100% - 8px)',
              aspectRatio: '1',
              maxHeight: '300px',
              border: '2px dashed',
              borderColor: 'divider',
              borderRadius: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'background.default',
              flexShrink: 0,
              boxSizing: 'border-box',
              mr: 1,
              overflow: 'hidden'
            }}>
              {!imageError ? (
                <img
                  src={`${getObstacleImageUrl(selectedObstacle.id, selectedObstacle.image)}?t=${Date.now()}`}
                  alt={selectedObstacle.name}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain'
                  }}
                  onError={onImageError}
                />
              ) : (
                <Typography color="textSecondary">
                  No image available
                </Typography>
              )}
            </Box>
            <Stack spacing={1}>
              <Typography variant="body2">
                <strong>Dimensions:</strong>
              </Typography>
              <Typography variant="body2">
                Width: {selectedObstacle.width.toFixed(2)} ft
              </Typography>
              <Typography variant="body2">
                Length: {selectedObstacle.length.toFixed(2)} ft
              </Typography>
              <Typography variant="body2">
                Height: {selectedObstacle.height.toFixed(2)} ft
              </Typography>
            </Stack>
          </Stack>
        ) : (
          <Typography color="textSecondary" sx={{ textAlign: 'center', mt: 4 }}>
            Select an obstacle to view details
          </Typography>
        )}
      </Stack>
    </Box>
  );
};